module.exports = __webpack_public_path__ + "img/750x860.5fcc35c5.jpg";